export interface GameSymbol {
  id: number;
  name: string;
  emoji: string;
  /** Original transparent PNG used for printing; screen variants live in /symbols/web/. */
  assetPath: string | null;
  color: string;
}

/** 57 illustrated symbols. IDs are shared by the deck, translations and PDF. */
export const SYMBOLS: readonly GameSymbol[] = [
  {
    "id": 0,
    "name": "Timbu masculin",
    "emoji": "🦝",
    "color": "#b83642",
    "assetPath": "/symbols/00-timbu-masculin.png"
  },
  {
    "id": 1,
    "name": "Mascotte féminine du Náutico",
    "emoji": "🐭",
    "color": "#cf5364",
    "assetPath": "/symbols/01-mascotte-feminine.png"
  },
  {
    "id": 2,
    "name": "Écusson du Náutico",
    "emoji": "🔰",
    "color": "#cf293a",
    "assetPath": "/symbols/02-ecusson-nautico.png"
  },
  {
    "id": 3,
    "name": "Maillot du Náutico",
    "emoji": "👕",
    "color": "#cf293a",
    "assetPath": "/symbols/03-maillot-nautico.png"
  },
  {
    "id": 4,
    "name": "Ballon de football",
    "emoji": "⚽",
    "color": "#536575",
    "assetPath": "/symbols/04-ballon-football.png"
  },
  {
    "id": 5,
    "name": "Chaussure à crampons",
    "emoji": "👟",
    "color": "#bb3542",
    "assetPath": "/symbols/05-chaussure-crampons.png"
  },
  {
    "id": 6,
    "name": "Gant de gardien",
    "emoji": "🧤",
    "color": "#d5a746",
    "assetPath": "/symbols/06-gant-gardien.png"
  },
  {
    "id": 7,
    "name": "But de football",
    "emoji": "🥅",
    "color": "#6b9593",
    "assetPath": "/symbols/07-but-football.png"
  },
  {
    "id": 8,
    "name": "Coupe de champion",
    "emoji": "🏆",
    "color": "#d1a13b",
    "assetPath": "/symbols/08-coupe-champion.png"
  },
  {
    "id": 9,
    "name": "Sifflet",
    "emoji": "📯",
    "color": "#7c8e9d",
    "assetPath": "/symbols/09-sifflet.png"
  },
  {
    "id": 10,
    "name": "Cartons jaune et rouge croisés",
    "emoji": "🟨",
    "color": "#d79d26",
    "assetPath": "/symbols/10-cartons-jaune-rouge.png"
  },
  {
    "id": 11,
    "name": "Clé du carnaval d’Olinda",
    "emoji": "🗝️",
    "color": "#8b99a3",
    "assetPath": "/symbols/11-cle-ville-olinda.png"
  },
  {
    "id": 12,
    "name": "Radio de supporter",
    "emoji": "📻",
    "color": "#b85046",
    "assetPath": "/symbols/12-radio-supporter.png"
  },
  {
    "id": 13,
    "name": "Tambour de tribune",
    "emoji": "🥁",
    "color": "#c65b3f",
    "assetPath": "/symbols/13-tambour-tribune.png"
  },
  {
    "id": 14,
    "name": "Mégaphone",
    "emoji": "📣",
    "color": "#c33c46",
    "assetPath": "/symbols/14-megaphone.png"
  },
  {
    "id": 15,
    "name": "Billet de match",
    "emoji": "🎟️",
    "color": "#bd8e48",
    "assetPath": "/symbols/15-billet-match.png"
  },
  {
    "id": 16,
    "name": "Drapeau du Náutico",
    "emoji": "🏳️",
    "color": "#c92e40",
    "assetPath": "/symbols/16-grand-drapeau-alvirrubro.png"
  },
  {
    "id": 17,
    "name": "Médaille de champion",
    "emoji": "🏅",
    "color": "#c79b38",
    "assetPath": "/symbols/17-medaille-champion.png"
  },
  {
    "id": 18,
    "name": "Ancre",
    "emoji": "⚓",
    "color": "#527589",
    "assetPath": "/symbols/18-ancre.png"
  },
  {
    "id": 19,
    "name": "Stade des Aflitos et QG",
    "emoji": "🏟️",
    "color": "#708991",
    "assetPath": "/symbols/19-stade-aflitos.png"
  },
  {
    "id": 20,
    "name": "Avirons croisés",
    "emoji": "🚣",
    "color": "#ad6942",
    "assetPath": "/symbols/20-avirons-croises.png"
  },
  {
    "id": 21,
    "name": "Galo da Madrugada",
    "emoji": "🐓",
    "color": "#df6b2d",
    "assetPath": "/symbols/21-galo-madrugada.png"
  },
  {
    "id": 22,
    "name": "Drapeau du Pernambuco",
    "emoji": "🌈",
    "color": "#2869a4",
    "assetPath": "/symbols/22-drapeau-pernambuco.png"
  },
  {
    "id": 23,
    "name": "Carte du Brésil",
    "emoji": "🗺️",
    "color": "#4b995c",
    "assetPath": "/symbols/23-carte-bresil.png"
  },
  {
    "id": 24,
    "name": "Toucan",
    "emoji": "🐦",
    "color": "#e4a43d",
    "assetPath": "/symbols/24-toucan.png"
  },
  {
    "id": 25,
    "name": "Ara multicolore",
    "emoji": "🦜",
    "color": "#d94a3c",
    "assetPath": "/symbols/25-ara-multicolore.png"
  },
  {
    "id": 26,
    "name": "Jaguar",
    "emoji": "🐆",
    "color": "#ca9440",
    "assetPath": "/symbols/26-jaguar.png"
  },
  {
    "id": 27,
    "name": "Requin de Boa Viagem",
    "emoji": "🦈",
    "color": "#6a8d9c",
    "assetPath": "/symbols/27-requin-boa-viagem.png"
  },
  {
    "id": 28,
    "name": "Cocotier de Boa Viagem",
    "emoji": "🌴",
    "color": "#4e955e",
    "assetPath": "/symbols/28-cocotier-boa-viagem.png"
  },
  {
    "id": 29,
    "name": "Jangada",
    "emoji": "⛵",
    "color": "#bb945d",
    "assetPath": "/symbols/29-jangada.png"
  },
  {
    "id": 30,
    "name": "Crabe du manguebeat",
    "emoji": "🦀",
    "color": "#a65854",
    "assetPath": "/symbols/30-crabe-manguebeat.png"
  },
  {
    "id": 31,
    "name": "Tour de Cristal de Brennand",
    "emoji": "🗼",
    "color": "#8f9a89",
    "assetPath": "/symbols/31-tour-cristal-brennand.png"
  },
  {
    "id": 32,
    "name": "Rose des vents du Marco Zero",
    "emoji": "🧭",
    "color": "#c9a34e",
    "assetPath": "/symbols/32-rose-vents-marco-zero.png"
  },
  {
    "id": 33,
    "name": "Pont Maurício de Nassau",
    "emoji": "🌉",
    "color": "#c58464",
    "assetPath": "/symbols/33-pont-mauricio-nassau.png"
  },
  {
    "id": 34,
    "name": "Maisons de la Rua do Bom Jesus",
    "emoji": "🏘️",
    "color": "#d79562",
    "assetPath": "/symbols/34-maisons-rua-bom-jesus.png"
  },
  {
    "id": 35,
    "name": "Ombrelle de frevo",
    "emoji": "☂️",
    "color": "#c74969",
    "assetPath": "/symbols/35-ombrelle-frevo.png"
  },
  {
    "id": 36,
    "name": "Pandeiro",
    "emoji": "🪘",
    "color": "#b89564",
    "assetPath": "/symbols/36-pandeiro.png"
  },
  {
    "id": 37,
    "name": "Maracatu — Caboclo de lança",
    "emoji": "🪅",
    "color": "#d5a23d",
    "assetPath": "/symbols/37-maracatu-caboclo-lanca.png"
  },
  {
    "id": 38,
    "name": "Boi Voador",
    "emoji": "🐂",
    "color": "#aa7753",
    "assetPath": "/symbols/38-boi-voador.png"
  },
  {
    "id": 39,
    "name": "Saci Pererê",
    "emoji": "🧢",
    "color": "#bf3e38",
    "assetPath": "/symbols/39-saci-perere.png"
  },
  {
    "id": 40,
    "name": "La Ursa",
    "emoji": "🐻",
    "color": "#b48b5b",
    "assetPath": "/symbols/40-la-ursa.png"
  },
  {
    "id": 41,
    "name": "Papangu de Bezerros",
    "emoji": "🎭",
    "color": "#8c6ba6",
    "assetPath": "/symbols/41-papangu-bezerros.png"
  },
  {
    "id": 42,
    "name": "Homem da Meia Noite",
    "emoji": "🎩",
    "color": "#37845c",
    "assetPath": "/symbols/42-homem-meia-noite.png"
  },
  {
    "id": 43,
    "name": "Cuca",
    "emoji": "🐊",
    "color": "#659d5d",
    "assetPath": "/symbols/43-cuca.png"
  },
  {
    "id": 44,
    "name": "Boitatá",
    "emoji": "🐍",
    "color": "#e98a2f",
    "assetPath": "/symbols/44-boitata.png"
  },
  {
    "id": 45,
    "name": "Carranca du São Francisco",
    "emoji": "👹",
    "color": "#956242",
    "assetPath": "/symbols/45-carranca-sao-francisco.png"
  },
  {
    "id": 46,
    "name": "Chapeau de cangaceiro",
    "emoji": "🤠",
    "color": "#ac7c49",
    "assetPath": "/symbols/46-chapeau-cangaceiro.png"
  },
  {
    "id": 47,
    "name": "Accordéon de forró",
    "emoji": "🪗",
    "color": "#b1474b",
    "assetPath": "/symbols/47-accordeon-forro.png"
  },
  {
    "id": 48,
    "name": "Fogueira de São João",
    "emoji": "🔥",
    "color": "#e28a30",
    "assetPath": "/symbols/48-fogueira-sao-joao.png"
  },
  {
    "id": 49,
    "name": "Canette de Guaraná Jesus",
    "emoji": "🥤",
    "color": "#de74a8",
    "assetPath": "/symbols/49-canette-guarana-jesus.png"
  },
  {
    "id": 50,
    "name": "Bouteille de Pitú",
    "emoji": "🍾",
    "color": "#bc3b32",
    "assetPath": "/symbols/50-bouteille-pitu.png"
  },
  {
    "id": 51,
    "name": "Coxinha",
    "emoji": "🍗",
    "color": "#c89652",
    "assetPath": "/symbols/51-coxinha.png"
  },
  {
    "id": 52,
    "name": "Cuscuz dans sa cuscuzeira",
    "emoji": "🍲",
    "color": "#d4b04c",
    "assetPath": "/symbols/52-cuscuz-cuscuzeira.png"
  },
  {
    "id": 53,
    "name": "Bolo de rolo",
    "emoji": "🧁",
    "color": "#c48d73",
    "assetPath": "/symbols/53-bolo-rolo.png"
  },
  {
    "id": 54,
    "name": "Tapioca",
    "emoji": "🫓",
    "color": "#b8a485",
    "assetPath": "/symbols/54-tapioca.png"
  },
  {
    "id": 55,
    "name": "Caju",
    "emoji": "🍐",
    "color": "#dc9140",
    "assetPath": "/symbols/55-caju.png"
  },
  {
    "id": 56,
    "name": "Açaí",
    "emoji": "🫐",
    "color": "#6d447c",
    "assetPath": "/symbols/56-bol-acai.png"
  }
];

export function getSymbol(id: number): GameSymbol {
  const symbol = SYMBOLS[id];
  if (!symbol || symbol.id !== id)
    throw new RangeError(`Symbole inconnu : ${id}.`);
  return symbol;
}
